module.exports = __webpack_public_path__ + "static/media/laboulangere.19b8bc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laboulangere.png
// module id = 1810
// module chunks = 0